import { Box } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import { createPath, ROUTE } from "app-constants/routing"
import InfiniteHorizontalScroller from "components/InfiniteHorizontalScroller"
import SmallVideoCard from "components/videos/SmallVideoCard"
import ConventionTag from "models/convention-api/v1/ConventionTag"
import ConventionVideoTagging from "models/convention-api/v1/ConventionVideoTagging"
import React, { useEffect, useRef } from "react"

const useStyles = makeStyles()(
  (theme) => ({
    container: {
      minHeight: 314, // card height + the scroller header
      width: "100%",
    },
    smallVideoCardContainer: {
      marginRight: theme.spacing(2),
      display: "flex",
      width: 250,
    },
  }),
)

interface ShuffledVideosByTagProps {
  tag: ConventionTag
  isVisible: boolean
  onLoad: () => void
}

export const ShuffledVideosByTag = (props: ShuffledVideosByTagProps) => {
  const { tag, onLoad, isVisible } = props
  const { classes } = useStyles()
  const onLoadCalledRef = useRef(false)
  const videos = ConventionVideoTagging.useMore({
    limit: 20,
    sort: "shuffled_position",
    filter: {
      convention_tag_id: tag.id,
    },
    includes: ["video", "video.video_count", "video.institution"],
  })

  useEffect(() => {
    if (videos.data !== undefined && !onLoadCalledRef.current) {
      onLoadCalledRef.current = true
      onLoad()
      return
    }
  }, [videos.data, isVisible])

  if (!isVisible) return null

  return (
    <Box className={classes.container}>
      <InfiniteHorizontalScroller
        title={tag.name}
        emptyStateMessage="No videos found"
        hasMore={videos.hasMore}
        loadMore={videos.loadMore}
        loading={videos.isLoading}>
        {videos.data?.map(({ video, convention_video_id }) => (
          <Box className={classes.smallVideoCardContainer} key={convention_video_id}>
            <SmallVideoCard
              href={createPath({ path: ROUTE.VIDEO, params: { videoId: convention_video_id } })}
              imageSrc={video?.thumbnail_url ?? ""}
              imageAlt=""
              curatorName={video?.institution?.name ?? ""}
              title={video?.name ?? `No title, video id - ${convention_video_id}`}
              numberOfViews={video?.video_count?.video_count ?? 0}
            />
          </Box>
        ))}
      </InfiniteHorizontalScroller>
    </Box>
  )
}
